import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface SaveFacilities {
  actionName: 'saveFacilities';
  request: mtechnavi.api.company.IBusinessUnitFacilities;
}

export const saveFacilities = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IBusinessUnitFacilities
) => {
  const createMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/CreateBusinessUnitFacilities';
  const updateMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/UpdateBusinessUnitFacilities';

  if (req.businessUnitFacilitiesId) {
    const result = await worker.invokeListRequest(updateMethodName, {
      businessUnitFacilities: req,
    });
    return result;
  } else {
    const result = await worker.invokeListRequest(createMethodName, {
      businessUnitFacilities: req,
    });
    return result;
  }
};
